import CryptoJS from "crypto-js";

export function decryptData(encryptedBase64) {
  try {
    const key = process.env.DECRYPT_LIVE_SECRET_KEY;
    const iv = process.env.DECRYPT_LIVE_SECRET_IV;

    // Auto-detect if Base64
    const isBase64 = /^[A-Za-z0-9+/=]+$/.test(key);
    const keyUtf8 = isBase64
      ? CryptoJS.enc.Base64.parse(key)
      : CryptoJS.enc.Utf8.parse(key);
    const ivUtf8 = isBase64
      ? CryptoJS.enc.Base64.parse(iv)
      : CryptoJS.enc.Utf8.parse(iv);

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64) },
      keyUtf8,
      {
        iv: ivUtf8,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const result = decrypted.toString(CryptoJS.enc.Utf8);
    return result || "**** Decryption Failed ****";
  } catch (err) {
    console.error("Decryption error:", err);
    return "**** Decryption Error ****";
  }
}
